import React from 'react';
import {useAuth} from '../util/auth';
import {useRouter} from 'next/router';
import DummyBox from './DummyBox';
import cn from 'clsx';

type SigninConditionalRendererProps = {
    buttonText: string;
    children: React.ReactNode;
    mode?: 'replace' | 'overlay';
    title?: string;
    authRequired?: boolean;
}

const SigninConditionalRenderer = ({
    buttonText,
    children,
    mode = 'replace',
    title,
    authRequired = true
}: SigninConditionalRendererProps) => {
    const auth = useAuth();
    const router = useRouter();

    if (auth.isAuthenticated || !authRequired) {
        return <>
            {children}
        </>;
    }

    if (mode === 'replace') {
        return <DummyBox
            className="my-4"
            title={title}
            buttonText={buttonText}
            buttonPath={`/auth/signin?next=${encodeURIComponent(router.asPath)}`}
        />
    }

    return (
        <div className={cn('relative group', {
            ['overflow-hidden hover:']: mode === 'overlay'
        })}>
            {children}
            <DummyBox
                className={cn('absolute inset-0 z-10 group:hover:opacity-1 group-hover:pointer-events-auto', {
                    ['pointer-events-none opacity-0 absolute transition-opacity duration-300 inset-0']: mode === 'overlay',
                })}
                title={title}
                buttonText={buttonText}
                buttonPath={`/auth/signin?next=${encodeURIComponent(router.asPath)}`}
            />
        </div>
    )
};

export default SigninConditionalRenderer;
